export const REGISTER_ACTION_TYPE = {
  SHOW_ALERT_INAPP: 'SHOW_ALERT_INAPP',
  SHOW_POPUP_EMAIL_REGISTER_COUPON: 'SHOW_POPUP_EMAIL_REGISTER_COUPON',
  REGISTER_COUPON: 'REGISTER_COUPON',
}

export const normalizeCheckRegisterAction = (rawData) => {
  if (!rawData) {
    return undefined
  }

  return {
    actionType: REGISTER_ACTION_TYPE[rawData?.action_type],
  }
}
